import { PureLightTheme } from "../../../styles/theme";

export const CardInfo = {
    width: '360px',
    maxHeight: '808px',
    height: '100%',
    overflowY: 'auto',
    padding: 5,
    '@media (max-width:1200px)': {
        width: '260px',
        paddingX: 3,
    },
    [PureLightTheme.breakpoints.down('md')] : {
        width: '100%',
        height: 'auto',
        padding: 1.5,
    },
    [PureLightTheme.breakpoints.down('sm')] : {
        padding: 0,
    },
}

export const StackStatictic = {
    [PureLightTheme.breakpoints.down('md')] : {
        flexDirection: 'row',
    }
}

export const TypStatictic = {
    fontWeight: 400,
}
